import { AccessProps } from "types";

export type DeveloperSidebarAccessProps = Omit<
  AccessProps,
  "hasAccessToOrganizationUserApi"
>;

export const canAccessFeedbackReports = (
  accessor: DeveloperSidebarAccessProps,
) => accessor.user.organization.feedbackReportEnabled;
